import { procurement as procurementEn } from '../en/procurement';

export const procurement = {
  ...procurementEn,
  payables: 'செலுத்த வேண்டியவை',
  supplierStatement: 'சப்ளையர் அறிக்கை',
  payablesDescription: "கொள்முதல் ஆர்டர்களிலிருந்து சப்ளையர்களுக்குச் செலுத்த வேண்டிய நிலுவைகள்",
  totalOutstanding: "மொத்த நிலுவை",
  supplier: "சப்ளையர்",
  phone: "தொலைபேசி",
  aging0to30: "0-30 நாட்கள்",
  aging31to60: "31-60 நாட்கள்",
  aging61to90: "61-90 நாட்கள்",
  aging90plus: "90+ நாட்கள்",
  noPayablesFound: "செலுத்த வேண்டிய நிலுவைகள் இல்லை",
  noPayablesFoundDescription: "அனைத்து சப்ளையர் நிலுவைகளும் தீர்க்கப்பட்டுள்ளன",
  failedToLoadPayables: "செலுத்த வேண்டியவற்றை ஏற்ற முடியவில்லை",
  searchBySupplierName: "சப்ளையர் பெயர் அல்லது தொலைபேசி மூலம் தேடவும்",
  openingBalance: "தொடக்க நிலுவை",
  closingBalance: "இறுதி நிலுவை",
  debit: "பற்று",
  credit: "வரவு",
  date: "தேதி",
  type: "வகை",
  reference: "குறிப்பு",
  balance: "நிலுவை",
  selectDateRange: "தேதி வரம்பைத் தேர்ந்தெடுக்கவும்",
  noTransactionsFound: "பரிவர்த்தனைகள் எதுவும் இல்லை",
  noTransactionsFoundDescription: "தேர்ந்தெடுக்கப்பட்ட தேதி வரம்பில் பரிவர்த்தனைகள் இல்லை",
  failedToLoadSupplierStatement: "சப்ளையர் அறிக்கையை ஏற்ற முடியவில்லை",
  transactionType_purchase_order: "கொள்முதல் ஆர்டர்",
  transactionType_supplier_payment: "கட்டணம்",
  transactionType_debit_note: "டெபிட் குறிப்பு",
  supplierStatementTitle: "சப்ளையர் அறிக்கை",
  thankYouMessage: "உங்கள் வணிகத்திற்கு நன்றி!",
  accountStart: "கணக்கு தொடக்கம்",
  today: "இன்று",
  statementPeriod: "காலம்",
  statementOrderHint: "பழையது முதலில் — இருப்பு மேலிருந்து கீழாக கணக்கிடப்படுகிறது",
};
